import {
  APP_KEY,
  APP_PATH
} from 'modules/app/constants'
import setReduxAction from 'modules/redux/actions/set'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import { REDUX_ACTION_PREFIX } from '@gymaholic/packages/src/modules/redux/constants/action.js'

export function updateShouldRenderNotFoundPageAction (value) {
  return setReduxAction({
    type: getActionStrReduxUtil(REDUX_ACTION_PREFIX.UPDATE, APP_KEY.SHOULD_RENDER_NOT_FOUND_PAGE),
    payload: {
      path: APP_PATH.SHOULD_RENDER_NOT_FOUND_PAGE,
      value
    }
  })
}
